import './App.css';
import { router } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React, { lazy, Suspense, useEffect } from 'react';
import ErrorBoundary from './Components/ErrorPages/ErrorBoundary';

// Lazy imports for heavy route components (used in router configuration)
const PageDetail    = lazy(() => import('./Pages/PageDetail/PageDetail'));
const Products      = lazy(() => import('./Components/Products/Products'));
const Profile       = lazy(() => import('./Components/Profile/Profile'));
const Marcas        = lazy(() => import('./Pages/Marcas/Marcas'));
const Atributos     = lazy(() => import('./Pages/Atributos/Atributos'));
const AtributosInfo = lazy(() => import('./Pages/AtributosInfo/AtributosInfo'));
const Resenas       = lazy(() => import('./Pages/Resenas/Resenas'));
const Apariencia    = lazy(() => import('./Pages/Apariencia/Apariencia'));

function App() {
  // Offline detection
  useEffect(() => {
    const handleOffline = () => {
      document.body.innerHTML = `
        <div style="display:flex;flex-direction:column;align-items:center;
          justify-content:center;min-height:100vh;text-align:center;
          font-family:sans-serif;gap:16px;padding:40px;">
          <span style="font-size:64px">📡</span>
          <h2 style="font-size:22px;margin:0">Sin conexión a internet</h2>
          <p style="color:#666;margin:0">Revisá tu conexión y volvé a intentarlo.</p>
          <button onclick="window.location.reload()"
            style="background:#023992;color:#fff;border:none;
            padding:10px 28px;border-radius:8px;font-size:15px;cursor:pointer;">
            Reintentar
          </button>
        </div>
      `;
    };
    window.addEventListener('offline', handleOffline);
    return () => window.removeEventListener('offline', handleOffline);
  }, []);

  return (
    <ErrorBoundary>
      <Suspense fallback={
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          fontSize: 16,
          color: '#666'
        }}>
          Cargando...
        </div>
      }>
        <RouterProvider router={router} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;